"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerComponents = exports.CustomerModels = void 0;
const customer_1 = require("./customer");
const customer_email_1 = __importDefault(require("./customer-email"));
// eslint-disable-next-line import/no-cycle
const customer_name_1 = __importDefault(require("./customer-name"));
const customer_phone_1 = __importDefault(require("./customer-phone"));
exports.CustomerModels = [
    customer_1.CustomerModel,
];
exports.CustomerComponents = [
    customer_name_1.default,
    customer_email_1.default,
    customer_phone_1.default,
];
